import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { connect } from 'react-redux';
import { getQueryParams } from 'utils/UrlUtil';
import { withRouter, Redirect } from 'react-router-dom';
import authActions from 'actions/Auth';
import { selectIsLoggedIn } from 'selectors/auth';

export default function requireAuthentication(Component) {
  class AuthenticatedComponent extends React.PureComponent {
    render() {
      if (!this.props.isLoggedIn) {
        this.props.preserveRoute(
          this.props.match.url + document.location.search + document.location.hash
        );
        return (
          <Redirect push to={`/auth${window.location.search}${window.location.hash}`} />
        );
      }

      return (
        <div style={{ height: '100%' }}>
          <Component {...this.props} />
        </div>
      );
    }
  }

  AuthenticatedComponent.propTypes = {
    isLoggedIn: PT.bool,
    preserveRoute: PT.func,
    match: PT.object
  };

  const mapStateToProps = state => ({
    isLoggedIn: selectIsLoggedIn(state)
  });

  const mapDispatchToProps = dispatch => ({
    preserveRoute: route => dispatch(authActions.preserveRoute(route, getQueryParams()))
  });

  return withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent));
}
